"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusAreasRepository = void 0;
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
exports.focusAreasRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "focusAreas",
        addNewRoute: "focusArea",
        editRoute: "focusArea",
        deleteRoute: "focusArea",
    },
    name: "focusAreas",
});
